import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { checkMaintenance, getMaintenance, MaintenanceInfo, subscribeMaintenance } from '../../services/maintenance';
import { formatDateTime } from '../../utils/formatters';

/**
 * 큐베이스 점검 띠 — 점검(쓰기 동결·DB 전환) 중에만 화면 맨 위에 걸린다 (services/maintenance).
 *
 * 앱 어디서든(로그인 화면·세션 확인 중 포함) 보여야 하므로 App 맨 바깥에 한 번 둔다. 화면 배치를 밀지 않도록
 * 위쪽 가운데에 매달린 얇은 띠로 띄운다. 처음 열 때 한 번 상태를 묻고, 그 뒤로는 응답·폴링이 갱신한다.
 */
const MaintenanceBanner: React.FC = () => {
  const { t } = useTranslation();
  const [info, setInfo] = useState<MaintenanceInfo | null>(getMaintenance());

  useEffect(() => {
    const off = subscribeMaintenance(setInfo);
    void checkMaintenance();
    return off;
  }, []);

  if (!info?.active) return null;

  let text: string;
  if (info.unreachable) {
    text = t('common:maintenance.switching');
  } else {
    const parts: string[] = [];
    if (info.message) parts.push(info.message);
    if (info.expiresAt) parts.push(t('common:maintenance.autoRelease', { time: formatDateTime(info.expiresAt, { seconds: false }) }));
    text = t('common:maintenance.readOnly') + (parts.length ? ` (${parts.join(', ')})` : '');
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 left-1/2 -translate-x-1/2 z-[10003] max-w-[90vw] px-4 py-1 rounded-b-md shadow-md border border-t-0 border-amber-300 bg-amber-50 text-amber-900 text-xs text-center pointer-events-none"
    >
      {text}
    </div>
  );
};

export default MaintenanceBanner;
